/* Podloge mape i sloj saobraćaja.

   Izdvojeno jer su to jedini delovi GPS mape koji zavise od SPOLJNIH izvora —
   kad se doda podloga ili promeni provajder saobraćaja, menja se samo ovaj
   fajl, a GPS.js ostaje netaknut.

   ── ZAŠTO OPENSTREETMAP, A NE GOOGLE ───────────────────────────────────────
   Google kao podloga je bio uveden pa izbačen (10.09.2026). Razlozi za OSM:
   ne traži ključ, ne košta, ne može da se ugasi zbog neplaćenog računa ili
   potrošene kvote, i ne vezuje dispečerski ekran za tuđi nalog.

   Google i dalje postoji, ali kao IZLAZ — „Otvori u Google Maps"
   (`googleLinkovi.js`) otvara tačku ili rutu u Google navigaciji, u novoj
   kartici. To su obične adrese, bez ključa i bez kvote. Podloga i navigacija
   su dve različite potrebe i rešavaju se odvojeno.

   ── ZAŠTO SAOBRAĆAJ TRAŽI POSEBAN IZVOR ────────────────────────────────────
   OpenStreetMap NEMA podatke o saobraćaju. To nije sloj koji se „upali" nad
   postojećom mapom — gustina se meri iz flote uređaja i prodaje se kao
   zasebna usluga. Sve što nam treba je RASTER pločica (obična slika po
   z/x/y), jer se takva ucrtava nad bilo kojom podlogom bez ijedne nove
   biblioteke.

   Zato saobraćaj NIJE vezan za jednog provajdera nego za URL šablon: ko god
   isporučuje raster pločice, ubacuje se bez izmene koda. */

export const SLOJEVI = [
    {
        kljuc: 'MAPA',
        naziv: 'gps.slojMapa',
        opis: 'gps.slojMapaOpis',
        ikona: 'pi pi-map',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        maxZoom: 19,
        atribucija: '© OpenStreetMap',
    },
    {
        /* Satelit nije ukras: dispečeru pokazuje raspored kruga fabrike i gde je
           rampa, što se iz linijske mape ne vidi, a vozač po tome traži ulaz. */
        kljuc: 'SATELIT',
        naziv: 'gps.slojSatelit',
        opis: 'gps.slojSatelitOpis',
        ikona: 'pi pi-globe',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        maxZoom: 19,
        atribucija: '© Esri, Maxar, Earthstar Geographics',
    },
    {
        /* Topografska podloga — nadmorska visina i nagib. Prevoj koji zimi
           zaledi ili uspon na kom šleper stane ne vide se na običnoj mapi, a
           odlučuju o tome kojim putem se šalje vozilo. */
        kljuc: 'TEREN',
        naziv: 'gps.slojTeren',
        opis: 'gps.slojTerenOpis',
        ikona: 'pi pi-chart-line',
        url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
        maxZoom: 17,
        atribucija: '© OpenStreetMap, SRTM · © OpenTopoMap (CC-BY-SA)',
    },
];

export const podrazumevaniSloj = SLOJEVI[0];

export const nadjiSloj = (kljuc) =>
    SLOJEVI.find(x => x.kljuc === kljuc) || podrazumevaniSloj;

/* ── saobraćaj ─────────────────────────────────────────────────────────────
   Ključ provajdera se ovde NE čita.

   Pločice gustine povlači sam pregledač, pa ključ mora da bude u njihovoj
   adresi — ali šablon sklapa BACKEND i šalje ga kroz `/gps/pretragaInit`.
   Tako ključ živi na jednom mestu (`TMS_Backend/.env`), ne ulazi u frontend
   build ni repozitorijum, a izmena ne traži rebuild fronta.

   Ovde ostaju samo funkcije koje rade nad tim, već sklopljenim podešavanjem. */

export const imaSaobracaj = (konfig) => !!(konfig && konfig.url);
/* Kompaktan zapis za config.PodesavanjaOperatera.vrednost (NVARCHAR(200)).
   Čitanje je popustljivo — pokvaren zapis vraća podrazumevano, jer je ostati
   bez mape gore od izgubljene postavke. */
export const upakujMapu = (st) => JSON.stringify({ s: st.sloj, t: st.saobracaj ? 1 : 0 });

export const raspakujMapu = (tekst) => {
    const podrazumevano = { sloj: podrazumevaniSloj.kljuc, saobracaj: false };
    if (!tekst) return podrazumevano;
    try {
        const p = JSON.parse(tekst);
        return {
            sloj: nadjiSloj(p.s).kljuc,
            /* Zastavica se vraća kakva je sačuvana. Da li se sloj STVARNO crta
               zavisi od toga da li je backend poslao šablon — a to se u ovom
               trenutku još ne zna, jer podešavanje stiže istim pozivom. */
            saobracaj: !!p.t,
        };
    } catch (e) {
        return podrazumevano;
    }
};
